import React, { useState } from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import { TextInput } from '@els/els-react--text-input';
import { SingleSelect } from '@els/els-react--select';
import GSFNSubstances from '../GSFNSubstances';

import './GSFNDialog.scss';

function GSFNDialog({ options, onInputEnter, substances, onSubstanceSelect, ...otherProps }) {
  const [inputValue, setInputValue] = useState('');
  const [option, setOption] = useState(options[0]?.value || '');
  const MIN_QUERY_LENGTH = 3;

  const inputEnterHandler = (value) => {
    setInputValue(value);
    if (inputValue && inputValue.length >= MIN_QUERY_LENGTH) {
      onInputEnter(inputValue, option);
    }
  };

  return (
    <GeneralDialogLayout
      {...otherProps}
      movable={false}
      className="react-dialogs-scrollable insert-structure-from-name-dialog"
      header={<h4>Create structure template from name</h4>}>
      <div className="insert-structure-from-name-dialog__content">
        <div className="insert-structure-from-name-dialog__content__options">
          <SingleSelect
            label="Select option"
            shouldHideLabel
            data-e2e="insert-structure-from-name-dialog-option-select"
            options={options}
            optionsFlyoutProps={{
              noInternalPadding: true,
              theme: 'default',
              placement: 'bottom',
              pointer: true,
              pointerType: 'primary',
            }}
            selectedOptions={[option]}
            onSelect={setOption}
            className="insert-structure-from-name-dialog__content__options__select"
            required
          />
        </div>
        <div className="insert-structure-from-name-dialog__content__search">
          <TextInput
            data-e2e="search-structure"
            id="structureFromName-query"
            className="o-els-flex-layout__item o-els-flex-layout__item--grow"
            value={inputValue}
            onChange={(e) => setInputValue(e.target?.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                inputEnterHandler(e.target?.value);
              }
            }}
            shouldHideLabel
            required
            label="Enter a chemical name, CAS-RN, InChiKey or SMILES"
            iconRight={{
              sprite: 'Search',
              id: 'search-icon',
              children: 'Search for structure',
              a11y: {
                name: 'Search',
              },
            }}
            iconRightCallback={() => inputEnterHandler()}
          />
        </div>
      </div>
      {substances && <GSFNSubstances substances={substances} onSubstanceSelect={onSubstanceSelect} />}
    </GeneralDialogLayout>
  );
}

GSFNDialog.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      isDisabled: PropTypes.bool,
    })
  ).isRequired,
  onInputEnter: PropTypes.func.isRequired,
  substances: PropTypes.array,
  onSubstanceSelect: PropTypes.func.isRequired,
};

export const typeOfGSFNDialog = 'typeOfGSFNDialog';
export default GSFNDialog;
